import { BudgetPhases } from 'business/constants';
import { translateBlockValue } from 'i18n';
import { getFieldForPhase } from '../shared/phases/helpers';
import { ExtraColumn } from './export';
import {
    getFieldValueFromPhase,
    InscriptionT,
    PhaseInscriptionT,
} from '../shared/entities/inscription';
import { PhaseFieldMapping } from '../config/constants';

export const groupInscriptionsByImputations = (
    inscriptionData: Record<string, ResponseDataValueT>[],
    phase: BudgetPhases,
) => {
    const amountField = getFieldForPhase(phase, 'amount');
    const commentField = getFieldForPhase(phase, 'comment');
    const statusField = 'status';
    return Object.values(
        inscriptionData.reduce(
            (acc: Record<string, Record<string, ResponseDataValueT>>, item) => {
                const {
                    [amountField]: amount,
                    [commentField!]: comment,
                    [statusField!]: status,
                    ...rest
                } = item;
                const key = JSON.stringify(rest);
                if (!acc[key]) {
                    acc[key] = {
                        ...item,
                        [amountField]: 0,
                        [commentField!]: '',
                        [statusField!]: '',
                    };
                }
                // @ts-expect-error [TS migration] ResponseDataValueT should be generic<T>
                acc[key][amountField] += amount;
                acc[key][commentField!] += acc[key][commentField!]
                    ? `\n${comment}`
                    : `${comment}`;
                acc[key][statusField!] += acc[key][statusField!]
                    ? `\n${translateBlockValue(String(status))}`
                    : `${translateBlockValue(String(status))}`;
                return acc;
            },
            {},
        ),
    );
};

export const getPhaseSpecificColumns = (
    phase: BudgetPhases,
    fields: (keyof PhaseInscriptionT)[],
): ExtraColumn[] => {
    return PhaseFieldMapping.filter((p) => p.phase === phase).flatMap((p) =>
        fields.map((field) => ({
            label: undefined,
            field,
            key: `${p.key}.${field}`,
            getValue: (data: InscriptionT) =>
                getFieldValueFromPhase(p.phase, field, data) ?? '',
            type: 'text',
        })),
    );
};

/**
 * Check if the label is undefined. Empty string is not undefined, nor is null. We want
 * to be able to have an empty column on the Excel export, so we can't just check for
 * falsy values.
 */
export const isLabelUndefined = (label: string | undefined) =>
    label === undefined;
